import { Plus, Wallet } from 'lucide-react';
import PaymentMethodCard from './PaymentMethodCard';

export default function PaymentMethodsList({ 
  paymentMethods, 
  canAddMore, 
  onAddMethod, 
  onEdit, 
  onDelete, 
  onSetDefault 
}) {
  return (
    <div className="p-6 bg-white rounded-xl border border-gray-200 shadow-sm">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Payment Methods</h3>
        {canAddMore && (
          <button
            onClick={onAddMethod}
            className="flex gap-2 items-center px-3 py-2 text-sm font-medium text-emerald-600 bg-emerald-50 rounded-lg border border-emerald-200 transition-colors hover:bg-emerald-100"
          >
            <Plus size={16} />
            Add Method
          </button>
        )}
      </div>
      
      <div className="space-y-3">
        {paymentMethods.map((method) => (
          <PaymentMethodCard
            key={method.id}
            method={method}
            onEdit={onEdit}
            onDelete={onDelete}
            onSetDefault={onSetDefault}
          />
        ))}
        
        {paymentMethods.length === 0 && (
          <div className="py-8 text-center">
            <div className="flex justify-center items-center mx-auto mb-4 w-16 h-16 bg-gray-100 rounded-full">
              <Wallet className="w-8 h-8 text-gray-400" />
            </div>
            <p className="mb-2 text-sm text-gray-500">No payment methods added</p>
            <p className="mb-4 text-xs text-gray-400">Add a payment method to start receiving your commissions</p>
            <button
              onClick={onAddMethod}
              className="px-4 py-2 text-sm font-medium text-emerald-600 bg-emerald-50 rounded-lg border border-emerald-200 transition-colors hover:bg-emerald-100"
            >
              Add Payment Method
            </button>
          </div>
        )}

        {!canAddMore && paymentMethods.length > 0 && (
          <div className="p-3 bg-amber-50 rounded-lg border border-amber-200">
            <p className="text-xs text-center text-amber-700">
              Maximum of 5 payment methods reached. Remove one to add another.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
